import React from 'react';


export default function UntrackedChanges() {
    return (<div className="untracked-changes">
        Somebody has made changes to this map that you have not yet seen. Please refresh the page to see the latest version.
    </div>);
}